import i18n from '@/i18n';

/**
 * Translates coupon error messages using i18n
 */

const COUPON_ERROR_KEYS: Record<string, string> = {
  "Coupon not found": "couponErrors.notFound",
  "Coupon has expired": "couponErrors.expired",
  "Coupon has no uses remaining": "couponErrors.noUsesRemaining",
  "Coupon is not valid for this plan": "couponErrors.invalidForPlan",
  "Coupon is not valid for this recurrency": "couponErrors.invalidForRecurrency",
};

/**
 * Translates a coupon error message
 * @param error - The error message in English
 * @returns The translated error message, or the original if no translation exists
 */
export function translateCouponError(error: string): string {
  const key = COUPON_ERROR_KEYS[error];
  return key ? i18n.t(key) : error;
}
